import Select from "antd/es/select";
import React from "react";
import { useTranslation } from "react-i18next";
import { DateInput } from "semantic-ui-calendar-react";
import { Button, Icon } from "semantic-ui-react";
import functionCommon from "../../core/common/function";
import { employeeStatus } from "../../core/constant/allLeaveRequest.constants";
import { leaveStatusLabel } from "../../core/constant/myLeaveRequest.constants";
import "./styles.scss";

export default function LeaveSearchConditionsForm(props) {
    const { t } = useTranslation();
    const {
        listLeaveType,
        listDepartment,
        listEmployee,
        listApprover,
        conditions,
        onChangeConditions,
        handleSearch,
        isSearching,
        dataError,
    } = props;

    const handlechangeDateFrom = (event, { name, value }) => {
        onChangeConditions({
            ...conditions,
            dayFrom: value,
        });
    };

    const handlechangeDateTo = (event, { name, value }) => {
        onChangeConditions({
            ...conditions,
            dayTo: value,
        });
    };

    const handleChangeCondition = (label, value) => (value) => {
        onChangeConditions({
            ...conditions,
            [label]: value,
        });
    };

    return (
        <div className="leave-search-condition-form">
            <div className="group-input date-input">
                <div className="date-input-item special">
                    <p className="label">{t("labels.date")}</p>
                    <div className="special-wrapper">
                        <p className="from-label">{t("labels.from")}</p>
                        <DateInput
                            className="date-picker leave-date-input-restrict"
                            name="date"
                            placeholder="DD-MM-YYYY"
                            iconPosition="right"
                            animation="none"
                            dateFormat="DD-MM-YYYY"
                            value={conditions.dayFrom}
                            onChange={handlechangeDateFrom}
                            closeOnMouseLeave={false}
                            localization={localStorage.getItem("i18nextLng") === "en" ? "en" : "vi"}
                            hideMobileKeyboard={true}
                            autoComplete="off"
                            maxLength="0"
                            closable={true}
                            onKeyDown={functionCommon.onKeyDownDateInput}
                            onMouseEnter={functionCommon.onMouseEnterDateInput}
                            onMouseLeave={functionCommon.onMouseLeaveDateInput}
                        />
                    </div>
                </div>
                <div className="date-input-item">
                    <p className="to-label">{t("labels.to")}</p>
                    <DateInput
                        className="date-picker leave-date-input-restrict"
                        name="date"
                        placeholder="DD-MM-YYYY"
                        iconPosition="right"
                        animation="none"
                        dateFormat="DD-MM-YYYY"
                        value={conditions.dayTo}
                        onChange={handlechangeDateTo}
                        closeOnMouseLeave={false}
                        localization={localStorage.getItem("i18nextLng") === "en" ? "en" : "vi"}
                        hideMobileKeyboard={true}
                        autoComplete="off"
                        maxLength="0"
                        closable={true}
                        onKeyDown={functionCommon.onKeyDownDateInput}
                        onMouseEnter={functionCommon.onMouseEnterDateInput}
                        onMouseLeave={functionCommon.onMouseLeaveDateInput}
                    />
                </div>
            </div>
            {dataError.day && (
                <div className="group-input date-input">
                    <div className="text-error">
                        <p className="error-message error-day">{t(dataError.day)}</p>
                    </div>
                </div>
            )}
            <div className="group-input select-group">
                <div className="normal-input special">
                    <p className="label">{t("labels.leaveType")}</p>
                    <Select value={conditions.leaveTypeId} onChange={handleChangeCondition("leaveTypeId")}>
                        <Select.Option value="" label="All">
                            All
                        </Select.Option>
                        {listLeaveType.length > 0 &&
                            listLeaveType.map((ele, idx) => {
                                return (
                                    <Select.Option key={idx} value={ele.value}>
                                        {ele.name}
                                    </Select.Option>
                                );
                            })}
                    </Select>
                </div>
                <div className="normal-input">
                    <p className="label">{t("labels.status")}</p>
                    <Select value={conditions.requestStatus} onChange={handleChangeCondition("requestStatus")}>
                        <Select.Option value="">All</Select.Option>
                        {Object.values(leaveStatusLabel).map((ele, idx) => (
                            <Select.Option key={idx} value={idx}>
                                {t("labels." + ele.toLowerCase())}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            </div>
            <div className="group-input select-group">
                <div className="normal-input special">
                    <p className="label">{t("navigation.department")}</p>
                    <Select
                        showSearch
                        filterOption={(input, option) =>
                            option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        value={conditions.departmentId}
                        onChange={handleChangeCondition("departmentId")}
                    >
                        <Select.Option value="" label="All">
                            All
                        </Select.Option>
                        {listDepartment.length > 0 &&
                            listDepartment.map((ele, idx) => {
                                return (
                                    <Select.Option key={idx} value={ele.value} label={ele.name}>
                                        {ele.name}
                                    </Select.Option>
                                );
                            })}
                    </Select>
                </div>
                <div className="normal-input">
                    <p className="label">{t("labels.employee")}</p>
                    <Select
                        showSearch
                        filterOption={functionCommon.filterEmployee}
                        value={conditions.employeeId}
                        onChange={handleChangeCondition("employeeId")}
                    >
                        <Select.Option value="" label="All">
                            All
                        </Select.Option>
                        {listEmployee.length > 0 &&
                            listEmployee.map((ele, idx) => {
                                return (
                                    <Select.Option key={idx} value={ele.value} label={ele.name}>
                                        {ele.name}
                                    </Select.Option>
                                );
                            })}
                    </Select>
                </div>
            </div>
            <div className="group-input select-group">
                <div className="normal-input special">
                    <p className="label">{t("labels.approver")}</p>
                    <Select
                        showSearch
                        filterOption={(input, option) =>
                            option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        value={conditions.approverId}
                        onChange={handleChangeCondition("approverId")}
                    >
                        <Select.Option value="" label="All">
                            All
                        </Select.Option>
                        {listApprover.length > 0 &&
                            listApprover.map((ele, idx) => {
                                return (
                                    <Select.Option key={idx} value={ele.value} label={ele.name}>
                                        {ele.name}
                                    </Select.Option>
                                );
                            })}
                    </Select>
                </div>
                <div className="normal-input">
                    <p className="label">{t("labels.employeeStatusLeave")}</p>
                    <Select value={conditions.employeeStatus} onChange={handleChangeCondition("employeeStatus")}>
                        <Select.Option value="">All</Select.Option>
                        {Object.values(employeeStatus).map((ele, idx) => (
                            <Select.Option key={idx} value={idx}>
                                {t("labels." + ele)}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            </div>
            <div className="btn-wrapper">
                <Button className="leave-button" onClick={handleSearch} disabled={isSearching}>
                    <Icon name="search" />
                    {isSearching ? t("button.searching") : t("button.search")}
                </Button>
            </div>
        </div>
    );
}
